module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("今日已完成訂單數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.ordersAmount.today.amount))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("今日成交金額")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.ordersAmount.today.money))])])])]), _vm._v(" "), (_vm.roleType == 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("總會員")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.shoppersAmount))])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("今日退訂金額")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.disAmount.today))])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("今日賣出份數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.successItem.today))])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("今日未完成筆數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.errorAmount.today))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積總訂單數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.ordersAmount.total.amount))])])])]), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積成交金額")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.ordersAmount.total.money))])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積退訂金額")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.disAmount.total))])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType != 99) ? _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積賣出份數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.successItem.total))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-6 col-xs-12 p-x-10",
    class: {
      'col-lg-20-p': _vm.roleType != 99
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text m-t-5"
  }, [_vm._v("累積錯誤筆數")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number text-35"
  }, [_vm._v(_vm._s(_vm.errorAmount.total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 p-r-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("即時訂單狀態數量統計")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [_c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(12), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.allStatistic.total.amount) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.noAccept.amount) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.accept.amount) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.refuse.amount) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.done.amount) + "筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.del.amount) + "筆")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 p-l-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("即時訂單狀態金額統計")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [_c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(14), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.allStatistic.total.money) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.noAccept.money) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.accept.money) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.refuse.money) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.done.money) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allStatistic.del.money) + "元")])])])])])])])])]), _vm._v(" "), (_vm.roleType == 99 && _vm.topOrderAmount.brand) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("品牌成交量前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.topOrderAmount.brand.length !== 1) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._m(15), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.topOrderAmount.brand[0].brand_name))])]) : _vm._e(), _vm._v(" "), (_vm.topOrderAmount.brand.length !== 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.topOrderAmount.brand), function(brand, index) {
    return (index + 1 != _vm.topOrderAmount.brand.length) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    No." + _vm._s(index + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(brand.brand_name) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(brand.amount) + " 筆\n                  ")]), _vm._v(" "), (_vm.roleType == 30) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(brand.money) + " 元\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.roleType == 30) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(brand.item_count) + " 份\n                  ")]) : _vm._e()]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('h6', [_vm._v("其餘品牌共 " + _vm._s(_vm.topOrderAmount.brand[_vm.topOrderAmount.brand.length - 1].amount) + " 筆")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.roleType == 99 && _vm.topOrderAmount.store) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [(_vm.topOrderAmount.store.length) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.roleType == 30) ? _c('span', [_vm._v("今日")]) : _vm._e(), _vm._v("店家成交量前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.topOrderAmount.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._m(16), _vm._v(" "), (_vm.roleType === 99) ? _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.topOrderAmount.store[0].brand_name) + " - " + _vm._s(_vm.topOrderAmount.store[0].store_name))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 30) ? _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.topOrderAmount.store[0].store_name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.topOrderAmount.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.topOrderAmount.store), function(store, index) {
    return (index + 1 != _vm.topOrderAmount.store.length) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    No." + _vm._s(index + 1) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.roleType === 99) ? _c('span', [_vm._v(_vm._s(store.brand_name) + " - " + _vm._s(store.store_name))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 30) ? _c('span', [_vm._v(_vm._s(store.store_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.amount) + " 筆\n                  ")])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('h6', [_vm._v("其餘店家共 " + _vm._s(_vm.topOrderAmount.store[_vm.topOrderAmount.store.length - 1].amount) + " 筆")])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType == 30 && _vm.topTradeMoney.store) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [(_vm.topTradeMoney.store.length) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.roleType == 30) ? _c('span', [_vm._v("今日")]) : _vm._e(), _vm._v("店家成交金額前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.topTradeMoney.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._m(17), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.topTradeMoney.store[0].store_name))])]) : _vm._e(), _vm._v(" "), (_vm.topTradeMoney.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.topTradeMoney.store), function(store, index) {
    return (index + 1 != _vm.topTradeMoney.store.length) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    No." + _vm._s(index + 1) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.roleType === 99) ? _c('span', [_vm._v(_vm._s(store.brand_name) + " - " + _vm._s(store.store_name))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 30) ? _c('span', [_vm._v(_vm._s(store.store_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.money) + " 元\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.order_count) + " 筆\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.item_count) + " 份\n                  ")])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('h6', [_vm._v("其餘店家共 " + _vm._s(_vm.topTradeMoney.store[_vm.topTradeMoney.store.length - 1].money) + " 元")])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType == 30 && _vm.topRejectedMoney.store) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [(_vm.topRejectedMoney.store.length) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.roleType == 30) ? _c('span', [_vm._v("今日")]) : _vm._e(), _vm._v("店家退訂金額前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.topRejectedMoney.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._m(18), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.topRejectedMoney.store[0].store_name))])]) : _vm._e(), _vm._v(" "), (_vm.topRejectedMoney.store.length !== 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.topRejectedMoney.store), function(store, index) {
    return (index + 1 != _vm.topRejectedMoney.store.length) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    No." + _vm._s(index + 1) + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.roleType === 99) ? _c('span', [_vm._v(_vm._s(store.brand_name) + " - " + _vm._s(store.store_name))]) : _vm._e(), _vm._v(" "), (_vm.roleType === 30) ? _c('span', [_vm._v(_vm._s(store.store_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.money) + " 元\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.order_count) + " 筆\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                    " + _vm._s(store.item_count) + " 份\n                  ")])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('h6', [_vm._v("其餘店家共 " + _vm._s(_vm.topRejectedMoney.store[_vm.topRejectedMoney.store.length - 1].money) + " 元")])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType == 99) ? _c('div', {
    staticClass: "col-xs-12"
  }) : _vm._e(), _vm._v(" "), (_vm.roleType == 99) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('system-dashboard')], 1)]) : _vm._e(), _vm._v(" "), (_vm.roleType == 30) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('brand-dashboard')], 1)]) : _vm._e(), _vm._v(" "), (_vm.roleType == 10) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('order-line-charts')], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "reload-button"
  }, [_c('div', {
    staticClass: "btn btn-reload bg-red",
    on: {
      "click": function($event) {
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('i', {
    staticClass: "ion ion-document-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-cash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-ios-people"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-heart-broken"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-light-blue"
  }, [_c('i', {
    staticClass: "ion ion-wineglass"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-sad"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('i', {
    staticClass: "ion ion-document-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-cash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-heart-broken"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-light-blue"
  }, [_c('i', {
    staticClass: "ion ion-wineglass"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-sad"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "all-amount-brief",
      "height": "100"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("總訂單")]), _vm._v(" "), _c('th', [_vm._v("未接單")]), _vm._v(" "), _c('th', [_vm._v("已接單")]), _vm._v(" "), _c('th', [_vm._v("被退訂")]), _vm._v(" "), _c('th', [_vm._v("已完成")]), _vm._v(" "), _c('th', [_vm._v("已作廢")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "small-pie",
    attrs: {
      "id": "all-money-brief",
      "height": "100"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("總訂單")]), _vm._v(" "), _c('th', [_vm._v("未接單")]), _vm._v(" "), _c('th', [_vm._v("已接單")]), _vm._v(" "), _c('th', [_vm._v("被退訂")]), _vm._v(" "), _c('th', [_vm._v("已完成")]), _vm._v(" "), _c('th', [_vm._v("已作廢")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crying.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88c53092"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 2509
// module chunks = 1